import AppRecord from './AppRecord.js'

class BankImportRule extends AppRecord {

  get bankName(){
    if (this.cachedBankName == null) {
      this.cachedBankName = this.constructor.employeeStore.banks.find(bank => bank.id === this.bank_id)?.name
    }

    return this.cachedBankName
  }

  get entity(){
    if (this.cachedEntity == null) {
      this.cachedEntity = this.constructor.employeeStore.entitiesById.get(this.entity_id)
    }

    return this.cachedEntity
  }

  get depositName(){
    if (this.cachedDepositName == null) {
      this.cachedDepositName = this.constructor.employeeStore.deposits.find(deposit => deposit.id === this.deposit_id)?.name
    }

    return this.cachedDepositName
  }

  get accountName(){
    if (this.cachedAccountName == null) {
      this.cachedAccountName = this.constructor.employeeStore.accountsById.get(this.account_id)?.name
    }

    return this.cachedAccountName
  }

  get issue(){
    if (this.cachedIssue == null) {
      this.cachedIssue = this.constructor.employeeStore.issues.find(issue => issue.id === this.issue_id)
    }

    return this.cachedIssue
  }

  get issueName(){
    if (this.cachedIssueName == null) {
      this.cachedIssueName = this.constructor.employeeStore.issues.find(issue => issue.id === this.issue_id)?.name
    }

    return this.cachedIssueName
  }

  get reconciliationType(){
    return this.constructor.employeeStore.reconciliation_type_filter.find(reconciliation_type => reconciliation_type.reconciliation_type === this.reconciliation_type)?.label
  }

  get reconciliationAction(){
    return this.constructor.employeeStore.reconciliation_action_filter.find(reconciliation_action => reconciliation_action.reconciliation_action === this.reconciliation_action)?.label
  }
}
export default BankImportRule
